import i18next from "i18next";
import { surveyLocalization, Model } from "survey-core";


export const initCustomizedSurvey = () => {
  const PRUFORCE_DEFAULT_LANGUAGE = i18next.language
  switch (PRUFORCE_DEFAULT_LANGUAGE) {
    case "id":
      const indLocale = surveyLocalization.locales["id"];
      indLocale.modalCancelButtonText = "Batal";
      indLocale.confirmRemoveFile = "Anda yakin ingin menghapus file ini?";
      const surveyJson = {};
      const survey = new Model(surveyJson);
      survey.locale = "id";
      break;
    case "en":
      const endLocale = surveyLocalization.locales["id"];
      endLocale.modalCancelButtonText = "Cancel";
      endLocale.confirmRemoveFile = "Are you sure that you want to remove this file?";
      const enSurveyJson = {};
      const enSurvey = new Model(enSurveyJson);
      enSurvey.locale = ""; //default is en, set empty string will back to default.
      break;
    default:
      break;
  }
};
